// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagDisplay_tag__3rQ4c"};